import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconPeace: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconPeace"><Circle cx="12" cy="12" r="9.5" stroke="currentColor"/><Path d="M12 12L5.5 18.5" stroke="currentColor"/><Path d="M12 12L18.5 18.5" stroke="currentColor"/><Path d="M12 2.75V21.25" stroke="currentColor"/></CentralIconBase>;
});

export default IconPeace;
